import {
  Text,
  Button,
  Code,
  useClickAway,
  Link,
  Tooltip,
  Popover,
  Spacer,
  useToasts,
} from "@geist-ui/react";
import { useEffect, useRef, useState } from "react";
import Web3 from "web3";
import { CirclePicker } from "react-color";
import ABI from "./Square.json";

// const contractAddress = "0x34711A485aDb236Ba513EA6627021A281e439FAa";
const contractAddress = "0x4C54EC91799b1A72D54A0bFb0BAD1887570878be";

const GRID_SIZE = 10;
const COLORS = [
  "#f44336",
  "#e91e63",
  "#9c27b0",
  "#673ab7",
  "#3f51b5",
  "#2196f3",
  "#03a9f4",
  "#00bcd4",
  "#009688",
  "#4caf50",
  "#8bc34a",
  "#cddc39",
  "#ffeb3b",
  "#ffc107",
  "#ff9800",
  "#ff5722",
  "#795548",
  "#607d8b",
];

const expectedBlockTime = 4;
const colorToNumber = {};

for (var i = 0; i < COLORS.length; i++) {
  colorToNumber[COLORS[i]] = i;
}

const sleep = (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};
const SELECTED_NONE = { i: -1, color: "" };

const Cell = ({ cell, color, setSelected, selected, pickedColor }) => {
  const ref = useRef();
  // useClickAway(ref, () => {
  //   setSelected(SELECTED_NONE);
  // });

  const amSelected = selected.i === cell.i;
  if (amSelected) {
    console.log(pickedColor);
  }

  return (
    <div
      // ref={ref}
      className={`w-100 h-square ${amSelected && " border-t-4 border-black  "}`}
      style={{
        backgroundColor: amSelected ? pickedColor : cell.color,
      }}
      onClick={() => {
        // console.log(color);
        setSelected(cell);
      }}
    >
      {/* edit */}
    </div>
  );
};

const Picker = ({
  selected,
  setSelected,
  pickedColor,
  setPickedColor,
  account,
  setColorsUpdated,
}) => {
  const [previousOwners, setPreviousOwners] = useState([
    "0xe5A6D58868C0E90416f5783b122f98cd5F70440E",
    "0x46a73F5515991A22B79BBD69FebA8621E8F09E63",
    "0x34711A485aDb236Ba513EA6627021A281e439FAa",
    "0xA8A2044c5a7fF999620e95624EacF04E028eD2Bf",
  ]);

  useEffect(() => {
    if (selected) {
      setPickedColor(selected.color);
    }
  }, [selected]);

  useEffect(() => {
    // Fetch previous owners
  }, []);

  const [toasts, setToast] = useToasts();
  const [loading, setLoading] = useState(false);

  const x = Math.floor(selected.i / GRID_SIZE);
  const y = Math.floor(selected.i % GRID_SIZE);

  const mintColor = async (account) => {
    const colorNumber = colorToNumber[pickedColor];

    await window.ethereum.enable();
    window.web3 = new Web3(window.ethereum);

    // Call transaction with pickedColor
    const contract = new window.web3.eth.Contract(ABI, contractAddress);
    console.log(account);
    const params = {
      from: account,
      to: contractAddress,
      value: window.web3.utils.toWei("0.005", "ether"),
      gas: 100000,
    };
    console.log(params);
    const transaction = await contract.methods
      .buyCell(x, y, colorNumber)
      .send(params);
    const transactionHash = transaction["transactionHash"];
    console.log("Submitted transaction with hash: ", transactionHash);
    // setToast({ text: "Minting new pixel...", delay: 100000 });
    // console.log(transactionHash);
    let transactionReceipt = null;
    while (transactionReceipt == null) {
      console.log("Waiting");
      // Waiting expectedBlockTime until the transaction is mined
      transactionReceipt = await window.web3.eth.getTransactionReceipt(
        transactionHash
      );
      await sleep(expectedBlockTime);
    }
    console.log("Got the transaction receipt: ", transactionReceipt);
    // setToast({ text: "Pixel minted!", delay: 3 });

    // Update colors
    setColorsUpdated(true);
    setLoading(false);
    setSelected(SELECTED_NONE);
  };

  return (
    <div className="flex flex-col w-1/4 py-20 pl-20">
      {selected && (
        <div>
          <Text h2>
            Square ({x + 1}, {y + 1})
          </Text>

          <Link
            href={`https://testnets.opensea.io/assets/0x4c54ec91799b1a72d54a0bfb0bad1887570878be/${selected.i}`}
          >
            View on OpenSea
          </Link>

          <Text>
            You have selected pixel {selected.i + 1}. You can set each pixel to
            a new color (preview below) by paying 0.005Ξ to remint this pixel.
            You will then be added to the list of all owners for this pixel.
          </Text>

          <CirclePicker
            color={pickedColor}
            on
            onChangeComplete={(color) => {
              setPickedColor(color.hex);
            }}
          ></CirclePicker>
        </div>
      )}
      <div className="flex items-center pt-8 space-x-4">
        <Button
          auto
          shadow
          loading={loading}
          type="secondary"
          onClick={() => {
            console.log(account);
            if (account) {
              setLoading(true);
              mintColor(account).catch((e) => {
                setLoading(false);
              });
            }
          }}
        >
          Mint Color
        </Button>
        {!loading && (
          <Link
            href="#"
            onClick={() => {
              setSelected(SELECTED_NONE);
            }}
          >
            Cancel
          </Link>
        )}
      </div>
      <div className="mt-8">
        <Text h2>Previous Owners</Text>
        <Text>This is a work in progress. </Text>
        {previousOwners.map((addr) => {
          return (
            <div className="py-1">
              <Code>{addr}</Code>
            </div>
          );
        })}
      </div>
    </div>
  );
};

function App() {
  const [account, setAccount] = useState(null);
  const [selected, setSelected] = useState(SELECTED_NONE);

  const [colorsUpdated, setColorsUpdated] = useState(false);

  const provider = useRef(null);
  const web3 = useRef(null);

  const [colors, setColors] = useState([]);
  const [pickedColor, setPickedColor] = useState({});

  useEffect(() => {
    if (typeof window.ethereum !== "undefined") {
      console.log("MetaMask is installed!");
    }
    // Fetch  all colors on load from contract
    // setColors(
    //   [...Array(100).keys()].map((i) => ({
    //     i: i,
    //     color: COLORS[Math.floor(Math.random() * COLORS.length)],
    //   }))
    // );
  }, []);

  async function fetchColors() {
    await window.ethereum.enable();
    window.web3 = new Web3(window.ethereum);
    const contract = new window.web3.eth.Contract(ABI, contractAddress);
    console.log(contract);
    console.log(contract.methods);
    const canvas = await contract.methods.getCell().call();
    console.log(canvas);

    const colors = canvas.map((colorNumber, i) => ({
      i: i,
      color: COLORS[colorNumber],
    }));
    return colors;
  }

  useEffect(() => {
    async function fetch() {
      const _colors = await fetchColors();
      console.log("Got _colors");
      // console.log(_colors);
      setColors(_colors);
      setColorsUpdated(false);
    }
    fetch();

    // setColors();
  }, [colorsUpdated]);

  useEffect(() => {
    console.log("Colors updated");
  }, [colors]);

  const fetchAccount = async () => {
    const accounts = await window.ethereum.send("eth_requestAccounts");
    const account = accounts.result[0];
    console.log(accounts);
    setAccount(account);
  };

  useEffect(() => {
    console.log(colors);
  }, [colors]);

  const disconnectAccount = async () => {};

  return (
    <div className="flex h-full w-full justify-center">
      <div className="flex flex-col w-1/3 py-20">
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-row items-center space-x-4">
            <Text h1 className="my-0">
              SquareETH
            </Text>
          </div>

          <Button
            auto
            type={"primary"}
            size="small"
            onClick={async () => {
              if (!account) {
                fetchAccount();
              } else {
                disconnectAccount();
              }
            }}
          >
            {account ? "Disconnect" : "Connect"}
          </Button>
        </div>

        <div className="flex flex-row pt-4 space-x-8">
          <Link href="https://testnets.opensea.io/collection/unidentified-contract-rlnxuvzsww">
            OpenSea
          </Link>
          <Link href="https://faucets.chain.link/rinkeby">Rinkeby Faucet </Link>
        </div>

        <div className="flex flex-row pt-4 space-x-8">
          Grab some testnet ETH from the Rinkeby faucet, and then click on the
          "Connect" button before minting a pixel.
        </div>

        {/* Grid */}

        {window.ethereum.networkVersion !== "4" && (
          <Text>
            You are on the wrong network. Change your chain to Rinkeby in
            MetaMask and reload the page.
          </Text>
        )}
        <div class="grid grid-cols-10 gap-1 py-8">
          {colors.length > 0 &&
            colors.map((cell) => {
              // console.log(cell.color);
              // console.log(cell);
              return (
                <Cell
                  selected={selected}
                  setSelected={setSelected}
                  cell={cell}
                  pickedColor={pickedColor}
                ></Cell>
              );
            })}
        </div>
      </div>
      {selected.i >= 0 && (
        <Picker
          selected={selected}
          setSelected={setSelected}
          setColorsUpdated={setColorsUpdated}
          setPickedColor={setPickedColor}
          pickedColor={pickedColor}
          account={account}
        ></Picker>
      )}
    </div>
  );
}

export default App;
